import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className={styles.navbar}>
      <NavLink to="/hunger-games" end className={styles.logo} onClick={() => setIsOpen(false)}>
        HG
      </NavLink>

      <div className={styles.desktopMenu}>
        <NavLink to="/hunger-games" end className={styles.link}>
          Главная
        </NavLink>
        <NavLink to="/hunger-games/rules" className={styles.link}>
          Информация
        </NavLink>
      </div>

      <button
        className={`${styles.burger} ${isOpen ? styles.open : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Меню"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`${styles.mobileMenu} ${isOpen ? styles.open : ''}`}>
        <NavLink to="/hunger-games" end className={styles.mobileLink} onClick={() => setIsOpen(false)}>
          Главная
        </NavLink>
        <NavLink to="/hunger-games/rules" className={styles.mobileLink} onClick={() => setIsOpen(false)}>
          Правила
        </NavLink>
      </div>
    </nav>
  );
}
